namespace Nobox.Administration {
    export interface UserRow {
        UserId?: number;
        Username?: string;
        Source?: string;
        PasswordHash?: string;
        PasswordSalt?: string;
        DisplayName?: string;
        Email?: string;
        MobilePhoneNumber?: string;
        MobilePhoneVerified?: boolean;
        TwoFactorAuth?: TwoFactorAuthType;
        UserImage?: string;
        RoleIds?: string;
        Domain?: string;
        LastDirectoryUpdate?: string;
        IsActive?: number;
        Password?: string;
        PasswordConfirm?: string;
        ImpersonationToken?: string;
        Roles?: number[];
        TenantId?: number;
        TnNm?: string;
        Timezone?: number;
        CtryId?: number;
        Ctry?: string;
        Currencies?: string;
        CurrenciesPlace?: string;
        StatesId?: number;
        States?: string;
        CityId?: number;
        City?: string;
        Akses?: number;
        Status?: number;
        FormatDate?: string;
        CustomDate?: string;
        DisplayDate?: string;
        FormatTime?: string;
        CustomTime?: string;
        DisplayTime?: string;
        FormatNumber?: string;
        aSep?: string;
        dGroup?: string;
        aDec?: string;
        lZero?: string;
        mDec?: string;
        DisplayNumber?: string;
        LastLogin?: string;
        Date?: string;
        Online?: string;
        JmlConversation?: number;
        ReCon?: number;
        MsgSent?: number;
        AssCon?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace UserRow {
        export const idProperty = 'UserId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Username';
        export const localTextPrefix = 'Administration.User';
        export const lookupKey = 'Administration.User';

        export function getLookup(): Q.Lookup<UserRow> {
            return Q.getLookup<UserRow>('Administration.User');
        }
        export const deletePermission = 'Security';
        export const insertPermission = 'Security';
        export const readPermission = 'Security';
        export const updatePermission = 'Security';

        export declare const enum Fields {
            UserId = "UserId",
            Username = "Username",
            Source = "Source",
            PasswordHash = "PasswordHash",
            PasswordSalt = "PasswordSalt",
            DisplayName = "DisplayName",
            Email = "Email",
            MobilePhoneNumber = "MobilePhoneNumber",
            MobilePhoneVerified = "MobilePhoneVerified",
            TwoFactorAuth = "TwoFactorAuth",
            UserImage = "UserImage",
            RoleIds = "RoleIds",
            Domain = "Domain",
            LastDirectoryUpdate = "LastDirectoryUpdate",
            IsActive = "IsActive",
            Password = "Password",
            PasswordConfirm = "PasswordConfirm",
            ImpersonationToken = "ImpersonationToken",
            Roles = "Roles",
            TenantId = "TenantId",
            TnNm = "TnNm",
            Timezone = "Timezone",
            CtryId = "CtryId",
            Ctry = "Ctry",
            Currencies = "Currencies",
            CurrenciesPlace = "CurrenciesPlace",
            StatesId = "StatesId",
            States = "States",
            CityId = "CityId",
            City = "City",
            Akses = "Akses",
            Status = "Status",
            FormatDate = "FormatDate",
            CustomDate = "CustomDate",
            DisplayDate = "DisplayDate",
            FormatTime = "FormatTime",
            CustomTime = "CustomTime",
            DisplayTime = "DisplayTime",
            FormatNumber = "FormatNumber",
            aSep = "aSep",
            dGroup = "dGroup",
            aDec = "aDec",
            lZero = "lZero",
            mDec = "mDec",
            DisplayNumber = "DisplayNumber",
            LastLogin = "LastLogin",
            Date = "Date",
            Online = "Online",
            JmlConversation = "JmlConversation",
            ReCon = "ReCon",
            MsgSent = "MsgSent",
            AssCon = "AssCon",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
